import { Form } from './lib/form.js';
customElements.define('cipublic-form', Form);
//# sourceMappingURL=cipublic-form.js.map